import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { kurumIciSiralamaAyariSemasi, type KurumIciSiralamaAyari } from "@koclukpanel/contracts";
import { BosDurum, Buton, Iskelet, Kart } from "@koclukpanel/ui";
import { api } from "./api";

const AYAR_YOLU = "/deneme/ayarlar/kurum-ici-siralama";
const SORGU_ANAHTARI = ["deneme-siralama-ayari"];

/** F-EXM-22 — kurum ayarlarıyla aynı ekrandadır; varsayılan gizlilik sunucudan okunur. */
export function DenemeSiralamaAyari() {
  const sorgular = useQueryClient();
  const durum = useQuery({
    queryKey: SORGU_ANAHTARI,
    queryFn: () =>
      api<unknown>(AYAR_YOLU).then((yanit) => kurumIciSiralamaAyariSemasi.parse(yanit)),
    retry: false,
  });
  const kaydet = useMutation({
    mutationFn: (acik: boolean) =>
      api<KurumIciSiralamaAyari>(AYAR_YOLU, { yontem: "POST", govde: { acik } }),
    onSuccess: async (ayar) => {
      sorgular.setQueryData(SORGU_ANAHTARI, ayar);
      await sorgular.invalidateQueries({ queryKey: ["deneme"] });
    },
  });

  return (
    <Kart
      baslik="Kurum içi sıralama"
      aciklama="Varsayılan kapalıdır. Açıldığında öğrenci ve veli karnede sıralamayı görür."
    >
      {durum.isPending ? (
        <Iskelet satir={1} />
      ) : durum.isError ? (
        <BosDurum
          ton="hata"
          baslik="Sıralama ayarı alınamadı"
          eylem={
            <Buton gorunum="ikincil" onClick={() => void durum.refetch()}>
              Tekrar dene
            </Buton>
          }
        />
      ) : (
        <label className="flex items-center gap-3 text-sm">
          <input
            type="checkbox"
            role="switch"
            checked={durum.data.acik}
            disabled={kaydet.isPending}
            onChange={(olay) => kaydet.mutate(olay.target.checked)}
          />
          Kurum içi sıralamayı öğrenci ve veliye göster
        </label>
      )}
      {kaydet.isError && <p role="alert">{kaydet.error.message}</p>}
    </Kart>
  );
}
